const SESSION_STRAIN_TYPE = {
  INDICA: 0,
  SATIVA: 1,
  INDICA_HYBRID: 2,
  SATIVA_HYBRID: 3,
};

export default SESSION_STRAIN_TYPE;
